export class SearchResources200ResponseTablesInner {
    'resource';
    'source';
    'tables';
    'snapshots';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resource",
            "baseName": "resource",
            "type": "SearchResources200ResponseTablesInnerResource",
            "format": ""
        },
        {
            "name": "source",
            "baseName": "source",
            "type": "SearchResources200ResponseTablesInnerSource",
            "format": ""
        },
        {
            "name": "tables",
            "baseName": "tables",
            "type": "Array<SearchResources200ResponseTablesInnerTablesInner>",
            "format": ""
        },
        {
            "name": "snapshots",
            "baseName": "snapshots",
            "type": "SearchResources200ResponseTablesInnerSnapshots",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchResources200ResponseTablesInner.attributeTypeMap;
    }
    constructor() {
    }
}
